import { AxiosResponse } from 'axios'
import { DataService } from '../../utils/dataService'

export const LOAD_CITIES = 'LOAD_CITIES'
export const LOAD_ERROR = 'LOAD_ERROR'
export const LOAD_DEPARTAMENTS = 'LOAD_DEPARTAMENTS'
export const TOGGLE_POPPUP = 'TOGGLE_POPPUP'
export const TOGGLE_SHIPPINGMODAL = 'TOGGLE_SHIPPINGMODAL'
export const REQUEST_QUOTE = 'REQUEST_QUOTE'
export const ONCHANGE_DEFAULT_CITY = 'ONCHANGE_DEFAULT_CITY'
export const LOAD_PROVIDERS = 'LOAD_PROVIDERS'
export const RESET_QUOTE = "RESET_QUOTE"
export const LOAD_ERROR_QUOTE = "LOAD_ERROR_QUOTE"
export const TOGGLE_CITYCHANGED = 'TOGGLE_CITYCHANGED'
export const TOGGLE_CITYCHANGEMODALALERT = 'CITYCHANGEMODALALERT'
export const TOGGLE_CITYCHANGEALERT = 'CITYCHANGEALERT'
export const TOGGLE_SHOWALERTSELECTEDCITY = 'TOGGLE_SHOWALERTSELECTEDCITY'
export const LOAD_EDIT_PROD = "LOAD_EDIT_PROD"

export const handleLoadCities = () => (dispatch: any) => {
  // const _dataService = new DataService()
  // _dataService
  //   .post('/elogistica/cities', null)
  //   .then((res: AxiosResponse) => {
  //     if (res.data.success || res.data.status === "true") {
  //       dispatch({
  //         type: LOAD_CITIES,
  //         payload: {
  //           cities: res.data.data
  //         }
  //       })
  //     } else {
  //       dispatch({
  //         type: LOAD_ERROR,
  //         payload: {
  //           LoadError: true
  //         }
  //       })
  //     }
  //   })
}


export const handleLoadDepartaments = () => (dispatch: any) => { 
  // const _dataService = new DataService()
  // _dataService
  //   .post('/elogistica/departaments', null)
  //   .then((res: AxiosResponse) => {
  //     if (res.data.success || res.data.status === "true") {
  //       dispatch({
  //         type: LOAD_DEPARTAMENTS,
  //         payload: {
  //           departaments: res.data.data.map((item: any) => item.departamento)
  //         }
  //       })
  //     } else {
  //       dispatch({
  //         type: LOAD_ERROR,
  //         payload: {
  //           LoadError: true
  //         }
  //       })
  //     }
  //   })

}

export const handleTogglePoppup = () => (dispatch: any) => {
  dispatch({
    type: TOGGLE_POPPUP,
    payload: {}
  })
}

export const handleToggleShippingModal = (value: any) => (dispatch: any) => {
  dispatch({
    type: TOGGLE_SHIPPINGMODAL,
    payload: value
  })
}

export const handleRequestQuote = (payload: any) => (dispatch: any) => {
  const _dataService = new DataService()
  _dataService
    .post('/elogistica/quote', payload) 
    .then((res: AxiosResponse) => {
      if (res.data.status === "true") {
        dispatch({
          type: REQUEST_QUOTE,
          payload: Array.isArray(res.data.data) ? res.data.data.map((item: any) => { return {...item, valor: item.costo_total }}) : [{...res.data.data, valor: res.data.data.costo_total }]
        })
        return res.data;
      } else {
        if (res.data.data && res.data.data.code) {
          dispatch({
            type: LOAD_ERROR_QUOTE,
            payload: res.data.data.message === '' ? 'La ciudad de destino u origen seleccionada no esta disponible para el servicio' : res.data.data.message 
          })
        } else {
          dispatch({
            type: LOAD_ERROR,
            payload: {
              LoadError: true
            }
          })
        }
        return res.data
      }
    })
}
export const handleToggleCityChanged = () => (dispatch: any) => {
  dispatch({
    type: TOGGLE_CITYCHANGED,
    payload: {}
  })
}

export const handleToggleShowAlertSelectedCity = () => (dispatch: any) => {
  dispatch({
    type: TOGGLE_SHOWALERTSELECTEDCITY,
    payload: {}
  })
}

export const handleToggleCityChangeModalAlert = () => (dispatch: any) => {
  dispatch({
    type: TOGGLE_CITYCHANGEMODALALERT,
    payload: {}
  })
}

export const handleToggleCityChangeAlert = () => (dispatch: any) => {
  dispatch({
    type: TOGGLE_CITYCHANGEALERT,
    payload: {}
  })
}

export const handleOnchangeDefaultCity = (onchangeCity: any) => (dispatch: any) => {
  dispatch({
    type: ONCHANGE_DEFAULT_CITY,
    payload: onchangeCity
  })
}

export const handleLoadEditProd = (edit: any) => (dispatch: any) => {
  dispatch({
    type: LOAD_EDIT_PROD,
    payload: edit
  })
}

export const handleLoadProviders = () => (dispatch: any) => { 
  // const _dataService = new DataService()
  // _dataService
  //   .post('/elogistica/providers', null)
  //   .then((res: AxiosResponse) => {

  //     if (res.data.success || res.data.status === "true") {
  //       dispatch({
  //         type: LOAD_PROVIDERS,
  //         payload: {
  //           providers: res.data.data
  //         }
  //       })
  //     } else {
  //       dispatch({
  //         type: LOAD_ERROR,
  //         payload: {
  //           LoadError: true
  //         }
  //       })
  //     }
  //   })
}

export const handleResetQuote = () => (dispatch: any) => {
  dispatch({
    type: RESET_QUOTE,
    payload: ""
  })
}

export const  handleLoadErrorQuote = (message: string) => (dispatch: any) => {
  dispatch({
    type: LOAD_ERROR_QUOTE,
    payload: message
  })
}
